<ng-container *ngIf="activeLanguage$ | async as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'en'">

        <div class='coreInfo warranty-announcement-block'>
            <h1
                style='background-color: #154680; padding: 0 30px; line-height: 57px; height: 57px; display: block; width: 100%;font-size:24px; color:#fff;'>
                {{'coreReport.page_Title'|cxTranslate}}</h1>
            <div style='padding:20px;'>
                <p style='font-size:24px;color:#5b5b5b; font-weight:bold;'> {{'coreReport.p1'|cxTranslate}}</p>
                <p style='font-size:20px; color:#5b5b5b;'>{{'coreReport.p2'|cxTranslate}} <a
                        [href]='latestDocUrl$ |async ' class='im-pdf-icon' target='_blank'>
                        {{'coreReport.hyperlinkText1'|cxTranslate}} </a></p> <br>
                <ng-container *ngIf="userData$ | async as userData; else loggedOutLinks">
                    <p style='font-size:20px; color:#5b5b5b;'
                        *ngIf="userData?.isCoreSubmissionGroup || userData?.isCoreSearchGroup">
                        {{'coreReport.p3'|cxTranslate}}
                        <a href='/login'>{{'coreReport.hyperlinkText2'|cxTranslate}} </a>
                        {{'coreReport.p4'|cxTranslate}}
                    </p><br>
                    <p *ngIf="userData?.isCoreSubmissionGroup" style='margin:0;'><span
                            style='font-size:20px; color:#154680; font-weight:bold;'><a style='color:#0068b3;'
                                href='/kbCoreSubmissionPage' target="_blank">{{'coreReport.link1'|cxTranslate}}</a>
                        </span></p>
                    <p *ngIf="userData?.isCoreSubmissionGroup" style='margin:0;'><span
                            style='font-size:20px; color:#154680; font-weight:bold;'><a style='color:#0068b3;'
                                href='/search-coreReturn' target='_blank'
                                rel='noopener noreferrer'>{{'coreReport.link2'|cxTranslate}}</a></span>
                    </p>
                    <p *ngIf="userData?.isCoreSearchGroup" style='margin:0;'><span
                            style='font-size:20px; color:#154680; font-weight:bold;'><a style='color:#0068b3;'
                                href='/kbCoreReportsPage' target="_blank">{{'coreReport.link3'|cxTranslate}}</a></span>
                    </p>
                </ng-container>
                <ng-template #loggedOutLinks>
                    <p style='font-size:20px; color:#5b5b5b;'>
                        {{'coreReport.p3'|cxTranslate}}
                        <a href='/login'>{{'coreReport.hyperlinkText2'|cxTranslate}} </a>
                        {{'coreReport.p4'|cxTranslate}}
                    </p><br>
                    <p style='margin:0;'><span style='font-size:20px; color:#154680; font-weight:bold;'><a
                                style='color:#0068b3;' href='/kbCoreSubmissionPage'
                                target="_blank">{{'coreReport.link1'|cxTranslate}}</a>
                        </span></p>
                    <p style='margin:0;'><span style='font-size:20px; color:#154680; font-weight:bold;'><a
                                style='color:#0068b3;' href='/search-coreReturn' target='_blank'
                                rel='noopener noreferrer'>{{'coreReport.link2'|cxTranslate}}</a></span>
                    </p>
                    <p style='margin:0;'><span style='font-size:20px; color:#154680; font-weight:bold;'><a
                                style='color:#0068b3;' href='/kbCoreReportsPage'
                                target="_blank">{{'coreReport.link3'|cxTranslate}}</a></span>
                    </p>
                </ng-template>

            </div>
        </div>
    </ng-container>


    <ng-container *ngIf="activeLanguage === 'es_MX'">

        <div class='coreInfo warranty-announcement-block'>
            <h1
                style='background-color: #154680; padding: 0 30px; line-height: 57px; height: 57px; display: block; width: 100%;font-size:24px; color:#fff;'>
                {{'coreReport.page_Title'|cxTranslate}}</h1>
            <div style='padding:20px;'>
                <p style='font-size:24px;color:#5b5b5b; font-weight:bold;'>
                    {{'coreReport.p1'|cxTranslate}}</p>
                <p style='font-size:20px; color:#5b5b5b;'>{{'coreReport.p2'|cxTranslate}}</p>
                <ng-container *ngIf="userData$ | async as userData;else loggedOutLinks">
                    <p style='font-size:20px; color:#5b5b5b;'
                        *ngIf="userData?.isCoreSubmissionGroup || userData?.isCoreSearchGroup">
                        {{'coreReport.p3'|cxTranslate}}
                    </p>
                    <p style='margin:0;' *ngIf="userData?.isCoreSubmissionGroup">
                        <span style='font-size:20px; color:#154680; font-weight:bold;'>
                            <a style='color:#0068b3;' href='/kbCoreSubmissionPage'
                                target='_blank'>{{'coreReport.link1'|cxTranslate}}</a>
                        </span>
                    </p>
                    <p style='margin:0;' *ngIf="userData?.isCoreSubmissionGroup">
                        <span style='font-size:20px; color:#154680; font-weight:bold;'>
                            <a style='color:#0068b3;' href='/search-coreReturn' target='_blank'
                                rel='noopener noreferrer'>{{'coreReport.link2'|cxTranslate}}</a>
                        </span>
                    </p>
                    <p style='margin:0;' *ngIf="userData?.isCoreSearchGroup">
                        <span style='font-size:20px; color:#154680; font-weight:bold;'><a style='color:#0068b3;'
                                href='/kbCoreReportsPage' target='_blank'>{{'coreReport.link3'|cxTranslate}}

                            </a>
                        </span>
                    </p>
                </ng-container>
                <ng-template #loggedOutLinks>
                    <p style='font-size:20px; color:#5b5b5b;'>
                        {{'coreReport.p3'|cxTranslate}}
                    </p>
                    <p style='margin:0;'>
                        <span style='font-size:20px; color:#154680; font-weight:bold;'>
                            <a style='color:#0068b3;' href='/kbCoreSubmissionPage'
                                target="_blank">{{'coreReport.link1'|cxTranslate}}</a>
                        </span>
                    </p>
                    <p style='margin:0;'>
                        <span style='font-size:20px; color:#154680; font-weight:bold;'>
                            <a style='color:#0068b3;' href='/search-coreReturn' target='_blank'
                                rel='noopener noreferrer'>{{'coreReport.link2'|cxTranslate}}</a>
                        </span>
                    </p>
                    <p style='margin:0;'>
                        <span style='font-size:20px; color:#154680; font-weight:bold;'><a style='color:#0068b3;'
                                href='/kbCoreReportsPage' target="_blank">{{'coreReport.link3'|cxTranslate}}

                            </a>
                        </span>
                    </p>
                </ng-template>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="activeLanguage === 'fr_CA'">

        <div class='coreInfo warranty-announcement-block'>
            <h1
                style='background-color: #154680; padding: 0 30px; line-height: 57px; height: 57px; display: block; width: 100%;font-size:24px; color:#fff;'>
                {{'coreReport.page_Title'|cxTranslate}}</h1>
            <div style='padding:20px;'>
                <p style='font-size:24px;color:#5b5b5b; font-weight:bold;'>{{'coreReport.p1'|cxTranslate}}</p>
                <p style='font-size:20px; color:#5b5b5b;'>{{'coreReport.p2'|cxTranslate}}</p>
                <ng-container *ngIf="userData$ | async as userData;else loggedOutLinks">
                    <p style='font-size:20px; color:#5b5b5b;'
                        *ngIf="userData?.isCoreSubmissionGroup || userData?.isCoreSearchGroup">
                        {{'coreReport.p3'|cxTranslate}}
                    </p>

                    <p style='margin:0;' *ngIf="userData?.isCoreSubmissionGroup">
                        <span style='font-size:20px; color:#154680; font-weight:bold;'>
                            <a style='color:#0068b3;' href='/kbCoreSubmissionPage'
                                target="_blank">{{'coreReport.link1'|cxTranslate}}</a> </span>
                    </p>
                    <p style='margin:0;' *ngIf="userData?.isCoreSubmissionGroup"><span
                            style='font-size:20px; color:#154680; font-weight:bold;'><a style='color:#0068b3;'
                                href='/search-coreReturn' target='_blank'
                                rel='noopener noreferrer'>{{'coreReport.link2'|cxTranslate}}</a></span></p>
                    <p style='margin:0;' *ngIf="userData?.isCoreSearchGroup"><span
                            style='font-size:20px; color:#154680; font-weight:bold;'><a style='color:#0068b3;'
                                href='/kbCoreReportsPage' target="_blank">{{'coreReport.link3'|cxTranslate}}</a></span>
                    </p>
                </ng-container>
                <ng-template #loggedOutLinks>
                    <p style='font-size:20px; color:#5b5b5b;'>
                        {{'coreReport.p3'|cxTranslate}}
                    </p>

                    <p style='margin:0;'>
                        <span style='font-size:20px; color:#154680; font-weight:bold;'>
                            <a style='color:#0068b3;' href='/kbCoreSubmissionPage'
                                target="_blank">{{'coreReport.link1'|cxTranslate}}</a> </span>
                    </p>
                    <p style='margin:0;'><span style='font-size:20px; color:#154680; font-weight:bold;'><a
                                style='color:#0068b3;' href='/search-coreReturn' target='_blank'
                                rel='noopener noreferrer'>{{'coreReport.link2'|cxTranslate}}</a></span></p>
                    <p style='margin:0;'><span style='font-size:20px; color:#154680; font-weight:bold;'><a
                                style='color:#0068b3;' href='/kbCoreReportsPage'
                                target="_blank">{{'coreReport.link3'|cxTranslate}}</a></span>
                    </p>
                </ng-template>
            </div>
        </div>
    </ng-container>
</ng-container>